module.exports = __webpack_public_path__ + "1ba75826b7e8d5761cdd9a519d1ca06e.png";